<section class="content">
<div class="content-block">
<div style="padding:16px 24px;max-width:960px;">

  <div class="manuel-layout">

    <!-- Nav verticale -->
    <nav class="manuel-nav">
      <div class="manuel-nav-title">
        <mat-icon>list</mat-icon>
        Sommaire
      </div>
      <a *ngFor="let s of sections; let i = index"
         class="manuel-nav-link"
         [class.active]="activeSection === s.id"
         (click)="scrollTo(s.id)">
        <span class="nav-num">{{ i + 1 }}</span>
        {{ s.label }}
      </a>
    </nav>

    <!-- Sections -->
    <div class="manuel-sections">

  <!-- ===== À PROPOS ===== -->
  <div class="manuel-section" id="apropos" *ngIf="activeSection === 'apropos'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#235A66,#3CDBC2)">
      <div class="manuel-section-num"><mat-icon style="font-size:18px;width:18px;height:18px;">info</mat-icon></div>
      <mat-icon>info</mat-icon>
      <h3>À propos de HOTELGEX</h3>
    </div>
    <div class="manuel-section-body">
      <p>
        HotelGex est une suite logicielle complète dédiée à la gestion hôtelière. Elle repose sur quatre plateformes
        complémentaires, pensées pour couvrir l'ensemble des acteurs : l'opérateur SaaS, les hôtels clients,
        leurs résidents et le grand public.
      </p>

      <div class="features-grid" style="grid-template-columns:repeat(auto-fill,minmax(260px,1fr));">
        <div class="feature-card" style="background:#fff8ed;border-color:#f5dfa0;">
          <strong style="color:#b07a00;">HotelGex Backoffice <span style="font-size:10px;background:#b07a00;color:#fff;border-radius:10px;padding:1px 7px;font-weight:600;">Cette app</span></strong>
          Application utilisée par le personnel de l'hôtel (réceptionnistes, comptables, directeurs) pour gérer les réservations, hébergements, facturation et toutes les opérations quotidiennes de l'établissement.
        </div>
        <div class="feature-card" style="background:#f0fdf4;border-color:#a7e3bb;">
          <strong style="color:#1a7a3c;">HotelGex Mobile</strong>
          Application mobile destinée aux clients des hôtels. Permet de consulter les réservations en cours, accéder aux services de l'établissement, communiquer avec la réception et gérer son séjour depuis un smartphone.
        </div>
        <div class="feature-card" style="background:#f5f0ff;border-color:#d0b8f5;">
          <strong style="color:#6c3fc9;">HotelGex Web</strong>
          Portail grand public accessible depuis n'importe quel navigateur. Offre les mêmes fonctionnalités que l'application mobile : réservation en ligne, suivi de séjour, historique et préférences personnelles.
        </div>
      </div>

      <div class="tip" style="margin-top:16px;">
        <strong>Rôle du Backoffice</strong>
        Le Backoffice est l'outil central du personnel hôtelier. Il couvre l'ensemble des opérations : de l'accueil des clients jusqu'à la gestion financière, en passant par la restauration, la boutique et la relation client.
      </div>

      <h4 class="manuel-subsection" style="margin-top:20px;">Modules disponibles</h4>
      <div class="features-grid">
        <div class="feature-card"><strong>Accueil</strong>Réservations et hébergements depuis la réception.</div>
        <div class="feature-card"><strong>Restaurant</strong>Commandes et livraisons du restaurant.</div>
        <div class="feature-card"><strong>Boutique</strong>Vente d'articles en boutique.</div>
        <div class="feature-card"><strong>Location espace</strong>Réservation et occupation de salles.</div>
        <div class="feature-card"><strong>Trésorerie</strong>Caisses, dépenses, recettes et transferts.</div>
        <div class="feature-card"><strong>Relation client</strong>Remises, ristournes et fidélité.</div>
        <div class="feature-card"><strong>Paramètres</strong>Configuration de l'hôtel et des services.</div>
        <div class="feature-card"><strong>Administration</strong>Utilisateurs, rôles et habilitations.</div>
      </div>
    </div>
  </div>

  <!-- ===== CONNEXION ===== -->
  <div class="manuel-section" id="connexion" *ngIf="activeSection === 'connexion'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#4a90d9,#0665aa)">
      <div class="manuel-section-num">1</div>
      <mat-icon>login</mat-icon>
      <h3>Connexion</h3>
    </div>
    <div class="manuel-section-body">
      <p>L'accès à HOTELGEX se fait via la page de connexion. Trois scénarios sont possibles selon la situation de l'utilisateur.</p>

      <!-- Scénario 1 -->
      <div class="scenario-card">
        <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;">
          <span class="scenario-num blue">1</span>
          <strong style="font-size:14px;">Connexion standard</strong>
        </div>
        <p style="margin-bottom:8px;">Saisir le <strong>Login</strong> et le <strong>Mot de passe</strong> puis cliquer sur <em>Se connecter</em>.</p>
        <ul class="steps">
          <li>Entrer votre identifiant (login) dans le premier champ.</li>
          <li>Entrer votre mot de passe dans le second champ.</li>
          <li>Cliquer sur <strong>Se connecter</strong>.</li>
          <li>Si les identifiants sont corrects, vous accédez au tableau de bord.</li>
        </ul>
        <div style="margin-top:16px;text-align:center;">
          <img src="assets/images/manual/connexion.jpg" alt="Page de connexion"
               style="max-width:100%;border-radius:8px;border:1px solid #e2e8f0;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
        </div>
      </div>

      <!-- Scénario 2 : Première connexion -->
      <div class="scenario-card warning-card">
        <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;">
          <span class="scenario-num orange">2</span>
          <strong style="font-size:14px;">Première connexion — Changement de mot de passe obligatoire</strong>
        </div>
        <p style="margin-bottom:8px;">À la première connexion, le système redirige automatiquement vers la page <strong>Modifier le mot de passe</strong> avant d'accéder à l'application.</p>
        <ul class="steps">
          <li>Se connecter avec les identifiants fournis par l'administrateur.</li>
          <li>Le système redirige automatiquement vers <strong>Modifier le mot de passe</strong>.</li>
          <li>Saisir le mot de passe actuel (fourni par l'admin).</li>
          <li>Saisir un nouveau mot de passe personnel.</li>
          <li>Confirmer le nouveau mot de passe.</li>
          <li>Cliquer sur <strong>Modifier le mot de passe</strong> — l'accès est accordé.</li>
        </ul>
        <div class="warning">
          Cette étape est obligatoire. Le mot de passe par défaut ne permet pas d'accéder à l'application.
        </div>
        <div style="margin-top:16px;text-align:center;">
          <img src="assets/images/manual/modifier-mot-de-passe.jpg" alt="Modifier le mot de passe"
               style="max-width:100%;border-radius:8px;border:1px solid #fde68a;box-shadow:0 2px 8px rgba(0,0,0,0.08);"
               (error)="hideImg($event)">
        </div>
      </div>

      <!-- Scénario 3 : Mot de passe oublié -->
      <div class="scenario-card">
        <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;">
          <span class="scenario-num gray">3</span>
          <strong style="font-size:14px;">Mot de passe oublié</strong>
        </div>
        <p style="margin-bottom:8px;">Si l'utilisateur a oublié son mot de passe, il peut le réinitialiser depuis la page de connexion.</p>
        <ul class="steps">
          <li>Sur la page de connexion, cliquer sur <strong>Mot de passe oublié ?</strong></li>
          <li>Saisir votre <strong>login</strong> dans le champ prévu.</li>
          <li>Cliquer sur <strong>Réinitialiser mon mot de passe</strong>.</li>
          <li>Un nouveau mot de passe temporaire est généré.</li>
          <li>Se reconnecter avec le mot de passe temporaire reçu.</li>
          <li>Le système demande de définir un nouveau mot de passe personnel.</li>
        </ul>
        <div class="tip">
          <strong>Retour à la connexion</strong>
          Un lien <em>Connexion ?</em> permet de revenir à la page principale depuis ces écrans.
        </div>
        <div style="margin-top:16px;text-align:center;">
          <img src="assets/images/manual/mot-de-passe-oublie.jpg" alt="Mot de passe oublié"
               style="max-width:100%;border-radius:8px;border:1px solid #e2e8f0;box-shadow:0 2px 8px rgba(0,0,0,0.08);"
               (error)="hideImg($event)">
        </div>
      </div>
    </div>
  </div>

  <!-- ===== ACCUEIL ===== -->
  <div class="manuel-section" id="accueil" *ngIf="activeSection === 'accueil'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#3CDBC2,#235A66)">
      <div class="manuel-section-num">2</div>
      <mat-icon>support_agent</mat-icon>
      <h3>Accueil</h3>
    </div>
    <div class="manuel-section-body">
      <p>Le module Accueil permet de gérer les réservations et les hébergements en cours depuis la réception.</p>
      <div class="features-grid">
        <div class="feature-card">
          <strong>Réservation</strong>
          Créer et suivre les réservations de chambres à venir.
        </div>
        <div class="feature-card">
          <strong>Hébergement</strong>
          Gérer les occupations de chambres en cours (check-in / check-out).
        </div>
      </div>
      <ul class="steps" style="margin-top:16px;">
        <li>Cliquer sur <strong>Réservation</strong> ou <strong>Hébergement</strong> dans le menu Accueil.</li>
        <li>Utiliser le bouton <strong>+</strong> pour créer un nouvel enregistrement.</li>
        <li>Renseigner le client, la chambre, les dates et le montant avance.</li>
        <li>Pour régler, cliquer sur le bouton <strong>Règlement</strong> de la ligne concernée.</li>
        <li>Choisir le mode de règlement, la caisse et saisir le montant.</li>
      </ul>
      <div class="tip">
        <strong>Mode Fidélité</strong>
        Lors du règlement, si le client possède une carte de fidélité avec suffisamment de points, le mode <em>Fidélité</em> est activable. Le solde disponible est affiché directement dans la liste des modes.
      </div>
    </div>
  </div>

  <!-- ===== HEBERGEMENT ===== -->
  <div class="manuel-section" id="hebergement" *ngIf="activeSection === 'hebergement'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#FFAB2F,#e07b00)">
      <div class="manuel-section-num">3</div>
      <mat-icon>hotel</mat-icon>
      <h3>Hébergement</h3>
    </div>
    <div class="manuel-section-body">
      <p>Suivi des séjours en cours. Chaque hébergement est lié à une chambre, un client et une période.</p>
      <ul class="steps">
        <li>Sélectionner le service (nuitée, journée, séjour) pour filtrer les chambres disponibles.</li>
        <li>Choisir la chambre et le client — le montant total est calculé automatiquement.</li>
        <li>Enregistrer l'hébergement, puis procéder au règlement.</li>
        <li>Le bouton <strong>Imprimer</strong> génère le reçu de règlement.</li>
      </ul>
      <div class="warning">
        Le montant réglé ne peut pas dépasser le reste à régler. La monnaie rendue est calculée automatiquement (montant reçu − montant réglé).
      </div>
    </div>
  </div>

  <!-- ===== RESERVATION ===== -->
  <div class="manuel-section" id="reservation" *ngIf="activeSection === 'reservation'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#6c63ff,#3f3d9e)">
      <div class="manuel-section-num">4</div>
      <mat-icon>event_available</mat-icon>
      <h3>Réservation</h3>
    </div>
    <div class="manuel-section-body">
      <p>Gestion des réservations futures. Une réservation peut être convertie en hébergement à l'arrivée du client.</p>
      <ul class="steps">
        <li>Créer une réservation avec le client, la chambre et les dates souhaitées.</li>
        <li>Un montant d'avance peut être encaissé à la réservation.</li>
        <li>À l'arrivée du client, transformer la réservation en hébergement.</li>
        <li>Le montant déjà réglé est déduit automatiquement du reste à régler.</li>
      </ul>
    </div>
  </div>

  <!-- ===== RESTAURANT ===== -->
  <div class="manuel-section" id="restaurant" *ngIf="activeSection === 'restaurant'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#FF2742,#a3001a)">
      <div class="manuel-section-num">5</div>
      <mat-icon>restaurant</mat-icon>
      <h3>Restaurant</h3>
    </div>
    <div class="manuel-section-body">
      <p>Gestion des commandes et livraisons du restaurant de l'hôtel.</p>
      <div class="features-grid">
        <div class="feature-card">
          <strong>Menu restau</strong>
          Configurer les plats et boissons disponibles avec leurs prix.
        </div>
        <div class="feature-card">
          <strong>Commande</strong>
          Enregistrer les commandes clients avec les articles sélectionnés.
        </div>
        <div class="feature-card">
          <strong>Livraison</strong>
          Valider les livraisons et encaisser le règlement.
        </div>
      </div>
      <ul class="steps" style="margin-top:16px;">
        <li>Créer une commande en sélectionnant les articles du menu.</li>
        <li>La commande passe au statut <em>En attente</em>.</li>
        <li>Valider la livraison depuis la liste des commandes.</li>
        <li>Procéder au règlement (espèces, carte, ou fidélité si applicable).</li>
      </ul>
    </div>
  </div>

  <!-- ===== BOUTIQUE ===== -->
  <div class="manuel-section" id="boutique" *ngIf="activeSection === 'boutique'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#43e97b,#1a7a3c)">
      <div class="manuel-section-num">6</div>
      <mat-icon>storefront</mat-icon>
      <h3>Boutique</h3>
    </div>
    <div class="manuel-section-body">
      <p>Vente d'articles en boutique : commandes et livraisons.</p>
      <ul class="steps">
        <li>Créer une commande boutique avec les articles et quantités.</li>
        <li>Valider la livraison depuis la liste des commandes boutique.</li>
        <li>Régler la commande via le modal de règlement.</li>
      </ul>
      <div class="tip">
        <strong>Astuce</strong>
        Le stock est automatiquement mis à jour après chaque livraison validée.
      </div>
    </div>
  </div>

  <!-- ===== LOCATION ESPACE ===== -->
  <div class="manuel-section" id="location-espace" *ngIf="activeSection === 'location-espace'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#86AEAC,#4a7875)">
      <div class="manuel-section-num">7</div>
      <mat-icon>meeting_room</mat-icon>
      <h3>Location espace</h3>
    </div>
    <div class="manuel-section-body">
      <p>Gestion des réservations et occupations des salles de conférence et espaces événementiels.</p>
      <div class="features-grid">
        <div class="feature-card">
          <strong>Réservation espace</strong>
          Réserver une salle pour une date future avec options forfait.
        </div>
        <div class="feature-card">
          <strong>Occupation espace</strong>
          Gérer les occupations en cours et encaisser les règlements.
        </div>
      </div>
      <ul class="steps" style="margin-top:16px;">
        <li>Sélectionner l'espace et définir la période d'occupation.</li>
        <li>Choisir entre tarif normal ou tarif forfait si disponible.</li>
        <li>Encaisser le règlement via le bouton dédié.</li>
      </ul>
    </div>
  </div>

  <!-- ===== TRESORERIE ===== -->
  <div class="manuel-section" id="tresorerie" *ngIf="activeSection === 'tresorerie'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#00b4d8,#0077b6)">
      <div class="manuel-section-num">8</div>
      <mat-icon>account_balance</mat-icon>
      <h3>Trésorerie</h3>
    </div>
    <div class="manuel-section-body">
      <p>Suivi des mouvements financiers : caisses, dépenses, recettes et transferts de fonds.</p>
      <div class="features-grid">
        <div class="feature-card">
          <strong>Mouvement de caisse</strong>
          Consulter tous les encaissements et décaissements par caisse.
        </div>
        <div class="feature-card">
          <strong>Dépense</strong>
          Enregistrer les dépenses opérationnelles.
        </div>
        <div class="feature-card">
          <strong>Recette</strong>
          Consulter le récapitulatif des recettes.
        </div>
        <div class="feature-card">
          <strong>Transfert de fond</strong>
          Transférer des fonds entre caisses.
        </div>
        <div class="feature-card">
          <strong>Situation globale</strong>
          Vue d'ensemble de la situation financière.
        </div>
      </div>
      <div class="warning">
        Seuls les utilisateurs avec les habilitations appropriées peuvent valider les demandes de règlement et les transferts de fonds.
      </div>
    </div>
  </div>

  <!-- ===== RELATION CLIENT ===== -->
  <div class="manuel-section" id="relation-client" *ngIf="activeSection === 'relation-client'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#9F8DF1,#6c3fc9)">
      <div class="manuel-section-num">9</div>
      <mat-icon>handshake</mat-icon>
      <h3>Relation client</h3>
    </div>
    <div class="manuel-section-body">
      <p>Gestion des remises et ristournes accordées aux clients.</p>
      <div class="features-grid">
        <div class="feature-card">
          <strong>Remise hébergement</strong>
          Accorder une remise sur un hébergement terminé.
        </div>
        <div class="feature-card">
          <strong>Demande ristourne</strong>
          Traiter les demandes de remboursement partiel.
        </div>
        <div class="feature-card">
          <strong>Fidélité client</strong>
          Consulter et gérer les cartes de fidélité des clients.
        </div>
      </div>
    </div>
  </div>

  <!-- ===== FIDELITE ===== -->
  <div class="manuel-section" id="fidelite" *ngIf="activeSection === 'fidelite'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#FFAB2F,#FF6B35)">
      <div class="manuel-section-num">10</div>
      <mat-icon>star</mat-icon>
      <h3>Fidélité client</h3>
    </div>
    <div class="manuel-section-body">
      <p>Le programme de fidélité permet de récompenser les clients réguliers par des points convertibles en avantages financiers.</p>

      <h4 class="manuel-subsection">Comment ça marche</h4>
      <ul class="steps">
        <li>Chaque client peut avoir une <strong>carte de fidélité</strong> rattachée à son profil.</li>
        <li>Des points sont crédités automatiquement selon les règles de fidélité paramétrées (tranches de montants).</li>
        <li>Les points sont convertis en montant équivalent selon la valeur du point définie par niveau.</li>
        <li>Lors du règlement, si le client a suffisamment de points, le mode <strong>Fidélité</strong> est disponible.</li>
        <li>Le solde disponible et un avertissement en cas de points insuffisants sont affichés automatiquement.</li>
      </ul>

      <h4 class="manuel-subsection">Gérer la fidélité d'un client</h4>
      <ul class="steps">
        <li>Aller dans <em>Relation client → Fidélité client</em>.</li>
        <li>Rechercher le client dans la liste.</li>
        <li>Cliquer sur le bouton <strong>★</strong> (étoile) pour ouvrir la fiche fidélité.</li>
        <li>Créer la carte si elle n'existe pas encore.</li>
        <li>Ajouter ou retirer des points manuellement via le formulaire <em>Transaction de points</em>.</li>
        <li>Consulter l'historique complet des transactions.</li>
        <li>Imprimer la carte de fidélité physique.</li>
      </ul>

      <div class="tip">
        <strong>Niveaux de fidélité</strong>
        Les niveaux (Bronze, Argent, Or…) sont configurables dans <em>Paramètres → Paramètres hotel → Niveaux de fidélité</em>. Chaque niveau définit un seuil de points et une valeur de point en FCFA.
      </div>
      <div class="warning">
        La gestion des points (ajout/retrait) nécessite l'habilitation <strong>FIDELITE_CLIENT</strong>. La consultation de la liste est accessible à tous.
      </div>
    </div>
  </div>

  <!-- ===== PARAMETRES ===== -->
  <div class="manuel-section" id="parametres" *ngIf="activeSection === 'parametres'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#555,#222)">
      <div class="manuel-section-num">11</div>
      <mat-icon>settings</mat-icon>
      <h3>Paramètres</h3>
    </div>
    <div class="manuel-section-body">
      <p>Configuration de l'application : hôtel, restaurant, espaces et règles métier.</p>

      <h4 class="manuel-subsection">Paramètres généraux</h4>
      <ul>
        <li>Informations de l'hôtel, devise, fuseau horaire.</li>
      </ul>

      <h4 class="manuel-subsection">Paramètres hotel</h4>
      <ul>
        <li><strong>Types de chambre</strong> — Simple, Double, Suite, Familiale…</li>
        <li><strong>Chambres</strong> — Inventaire physique des chambres.</li>
        <li><strong>Services hôteliers</strong> — Prestations facturables avec périodicité.</li>
        <li><strong>Niveaux de fidélité</strong> — Bronze, Argent, Or… avec valeur de point.</li>
        <li><strong>Règles de fidélité</strong> — Tranches de montants pour l'attribution des points.</li>
      </ul>

      <h4 class="manuel-subsection">Paramètres restaurant</h4>
      <ul>
        <li>Articles, catégories, menu du restaurant.</li>
      </ul>

      <h4 class="manuel-subsection">Paramètres espace</h4>
      <ul>
        <li>Salles et espaces disponibles à la location avec capacités et tarifs.</li>
      </ul>
    </div>
  </div>

  <!-- ===== ADMINISTRATION ===== -->
  <div class="manuel-section" id="administration" *ngIf="activeSection === 'administration'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#235A66,#0d2e36)">
      <div class="manuel-section-num">12</div>
      <mat-icon>admin_panel_settings</mat-icon>
      <h3>Administration</h3>
    </div>
    <div class="manuel-section-body">
      <p>Gestion des utilisateurs, rôles et habilitations de la plateforme.</p>
      <div class="features-grid">
        <div class="feature-card">
          <strong>Utilisateurs</strong>
          Créer et gérer les comptes des agents de l'hôtel.
        </div>
        <div class="feature-card">
          <strong>Clients</strong>
          Gérer la base clients avec leurs informations et fidélité.
        </div>
        <div class="feature-card">
          <strong>Rôles</strong>
          Définir les rôles et les habilitations associées.
        </div>
        <div class="feature-card">
          <strong>Apporteurs</strong>
          Gérer les apporteurs d'affaires.
        </div>
      </div>

      <h4 class="manuel-subsection">Fonctionnalités &amp; Rôles</h4>
      <ul class="steps">
        <li>Créer un rôle et lui assigner les fonctionnalités autorisées.</li>
        <li>Créer un utilisateur et lui affecter un rôle.</li>
        <li>L'utilisateur voit uniquement les menus correspondant à ses habilitations.</li>
      </ul>
      <div class="tip">
        <strong>Habilitations</strong>
        Chaque menu de l'application est protégé par une codification (ex : <code>FIDELITE_CLIENT</code>, <code>HEBERGEMENT</code>…). Attribuer la fonctionnalité au rôle pour donner accès au menu.
      </div>
    </div>
  </div>

  <!-- ===== VUE CAISSE ===== -->
  <div class="manuel-section" id="vue-caisse" *ngIf="activeSection === 'vue-caisse'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#1a8a6c,#0d4f3e)">
      <div class="manuel-section-num">5</div>
      <mat-icon>point_of_sale</mat-icon>
      <h3>Vue Caisse</h3>
    </div>
    <div class="manuel-section-body">
      <p>
        La Vue Caisse est l'écran opérationnel central du personnel de réception. Elle affiche en temps réel tous les hébergements en cours
        selon le type de service sélectionné (Nuitée, Journée, Séjour, Pass, Espace, Boutique, Restaurant) et permet de gérer directement
        les opérations depuis une seule interface.
      </p>

      <h4 class="manuel-subsection">Types de vue disponibles</h4>
      <div class="features-grid">
        <div class="feature-card">
          <strong>Nuitée</strong>
          Hébergements à la nuit — affiche les chambres occupées avec leur date de sortie prévue.
        </div>
        <div class="feature-card">
          <strong>Journée</strong>
          Hébergements à la journée — occupation sur une demi-journée ou journée complète.
        </div>
        <div class="feature-card">
          <strong>Séjour</strong>
          Hébergements de longue durée — suivi de la progression du séjour avec barre de temps restant.
        </div>
        <div class="feature-card">
          <strong>Pass</strong>
          Mode passage rapide avec file d'attente — clients en attente d'une chambre disponible.
        </div>
        <div class="feature-card">
          <strong>Gestion espace</strong>
          Occupation des salles et espaces événementiels.
        </div>
        <div class="feature-card">
          <strong>Accueil boutique / Restau</strong>
          Vue caisse dédiée aux ventes boutique et commandes restaurant depuis la réception.
        </div>
      </div>

      <h4 class="manuel-subsection">Gestion des caisses</h4>
      <ul class="steps">
        <li>En haut de l'écran, les <strong>cartes de caisse</strong> affichent le solde actuel et l'état (Ouverte / Fermée).</li>
        <li>Cliquer sur une carte pour afficher le menu : <em>Voir détail</em> ou <em>Ouvrir / Fermer</em> la caisse.</li>
        <li>Le solde est mis à jour automatiquement à chaque encaissement ou transfert de fonds.</li>
      </ul>

      <h4 class="manuel-subsection">Actions sur un hébergement</h4>
      <ul class="steps">
        <li><strong>Règlement</strong> <em>(bouton vert)</em> — encaisser un paiement partiel ou total.</li>
        <li><strong>Sortir le client</strong> <em>(bouton rouge)</em> — enregistrer la sortie du client.</li>
        <li><strong>Menu « … »</strong> — accéder aux actions avancées :</li>
      </ul>
      <div class="features-grid" style="margin-top:8px;">
        <div class="feature-card"><strong>Commande restau</strong>Passer une commande restaurant rattachée à la chambre.</div>
        <div class="feature-card"><strong>Commande boutique</strong>Passer une commande boutique rattachée à la chambre.</div>
        <div class="feature-card"><strong>État des lieux</strong>Renseigner l'état des lieux d'entrée ou de sortie.</div>
        <div class="feature-card"><strong>Remise</strong>Appliquer une remise sur le montant total.</div>
        <div class="feature-card"><strong>Ristourne</strong>Accorder un remboursement partiel (sortie anticipée).</div>
        <div class="feature-card"><strong>Prolonger</strong>Étendre la durée du séjour ou du pass.</div>
        <div class="feature-card"><strong>Facture</strong>Imprimer la facture en PDF.</div>
      </div>

      <h4 class="manuel-subsection">Alertes de sortie imminente</h4>
      <div class="warning">
        Une bannière d'alerte apparaît automatiquement lorsqu'un client doit sortir dans moins de 20 minutes.
        Les niveaux sont : <strong>20 min</strong> (jaune), <strong>10 min</strong> (orange), <strong>Heure de sortie !</strong> (rouge).
        Cliquer sur la croix pour fermer une alerte.
      </div>

      <h4 class="manuel-subsection">File d'attente (mode Pass)</h4>
      <ul class="steps">
        <li>Cliquer sur le bouton <strong>File d'attente</strong> pour ouvrir le panneau latéral.</li>
        <li>Ajouter un client en attente avec son nom et son montant d'avance.</li>
        <li>Dès qu'une chambre se libère, sortir le client de la file via le bouton dédié.</li>
      </ul>

      <div class="tip">
        <strong>Clôture de la vue</strong>
        Le bouton <em>Clôturer</em> permet de générer un récapitulatif de la session de caisse en cours.
      </div>
    </div>
  </div>

  <!-- ===== STOCK ===== -->
  <div class="manuel-section" id="stock" *ngIf="activeSection === 'stock'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#2d6a4f,#1b4332)">
      <div class="manuel-section-num">8</div>
      <mat-icon>inventory_2</mat-icon>
      <h3>Gestion des stocks</h3>
    </div>
    <div class="manuel-section-body">
      <p>
        Le module Stock gère le cycle complet d'approvisionnement et de suivi des articles : commandes fournisseurs,
        réception des livraisons, consultation de l'état du stock en temps réel et réalisation d'inventaires.
      </p>
      <div class="warning">
        Ce module est distinct du module <strong>Boutique</strong>. La Boutique gère les <em>ventes aux clients</em>,
        tandis que le module Stock gère les <em>approvisionnements auprès des fournisseurs</em> et les niveaux de stock internes.
      </div>

      <h4 class="manuel-subsection">Commande fournisseur</h4>
      <ul class="steps">
        <li>Créer une commande en sélectionnant les articles et les quantités à commander.</li>
        <li>La commande est créée au statut <em>En attente</em>.</li>
        <li>Cliquer sur <strong>Valider</strong> pour confirmer la commande (irréversible).</li>
        <li>Ou <strong>Annuler</strong> pour abandonner la commande.</li>
        <li>Le bouton <strong>Éditer reçu</strong> génère un bon de commande en PDF.</li>
        <li>Cliquer sur la flèche d'une ligne pour voir le détail des articles commandés.</li>
      </ul>

      <h4 class="manuel-subsection">Livraison</h4>
      <ul class="steps">
        <li>Lorsque les marchandises arrivent, enregistrer la livraison correspondant à une commande validée.</li>
        <li>La réception met automatiquement à jour les quantités en stock.</li>
        <li>Un règlement fournisseur peut être saisi lors de la réception.</li>
      </ul>

      <h4 class="manuel-subsection">État du stock</h4>
      <ul class="steps">
        <li>Consulter en temps réel les quantités en stock pour chaque article.</li>
        <li>Filtrer par <strong>magasin</strong> pour voir le stock d'un entrepôt spécifique.</li>
        <li>Les badges de couleur indiquent l'état : <span style="background:#198754;color:#fff;padding:1px 6px;border-radius:4px;font-size:11px;">Normal</span>
          <span style="background:#ffc107;color:#000;padding:1px 6px;border-radius:4px;font-size:11px;margin:0 4px;">Alerte</span>
          <span style="background:#dc3545;color:#fff;padding:1px 6px;border-radius:4px;font-size:11px;">Rupture</span></li>
        <li>Le bouton <strong>Transfert magasin</strong> permet de déplacer du stock d'un entrepôt à un autre.</li>
        <li>Le bouton <strong>État Stock PDF</strong> génère un rapport imprimable.</li>
      </ul>

      <h4 class="manuel-subsection">Inventaire</h4>
      <ul class="steps">
        <li>Réaliser un inventaire physique pour corriger les écarts entre stock théorique et réel.</li>
        <li>Saisir les quantités comptées pour chaque article.</li>
        <li>Valider l'inventaire pour mettre à jour les niveaux de stock.</li>
      </ul>

      <h4 class="manuel-subsection">Sortie diverse</h4>
      <ul class="steps">
        <li>Enregistrer les sorties d'articles non liées à une vente (consommation interne, perte, don).</li>
        <li>Chaque sortie diminue le stock disponible et est tracée dans l'historique.</li>
      </ul>

      <div class="tip">
        <strong>Seuils d'alerte</strong>
        Les seuils d'alerte et de rupture sont configurables par article dans <em>Paramètres → Articles</em>.
        Le système déclenche automatiquement les indicateurs visuels dès que le stock atteint ces seuils.
      </div>
    </div>
  </div>

  <!-- ===== MAINTENANCE ===== -->
  <div class="manuel-section" id="maintenance" *ngIf="activeSection === 'maintenance'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#6c757d,#343a40)">
      <div class="manuel-section-num">13</div>
      <mat-icon>build</mat-icon>
      <h3>Maintenance</h3>
    </div>
    <div class="manuel-section-body">
      <p>
        Le module Maintenance permet de planifier et suivre les opérations de maintenance des chambres et espaces de l'hôtel
        (nettoyage, réparation, remise en état, maintenance préventive, etc.).
      </p>
      <div class="features-grid">
        <div class="feature-card">
          <strong>Programme</strong>
          Planifier les maintenances à venir avec les dates, le type, le lieu et le montant estimé.
        </div>
        <div class="feature-card">
          <strong>Exécution</strong>
          Suivre l'avancement des maintenances en cours et enregistrer les dates réelles de début et de fin.
        </div>
      </div>

      <h4 class="manuel-subsection">Planifier une maintenance (Programme)</h4>
      <ul class="steps">
        <li>Cliquer sur <strong>+ Nouvelle maintenance</strong>.</li>
        <li>Choisir la <strong>nature</strong> : <em>Programmée</em> (planifiée à l'avance) ou <em>Spontanée</em> (intervention d'urgence).</li>
        <li>Sélectionner le <strong>type de maintenance</strong> (ex : Plomberie, Électricité, Peinture…).</li>
        <li>Renseigner l'<strong>objet</strong> de l'intervention et la <strong>chambre ou l'espace</strong> concerné.</li>
        <li>Définir les <strong>dates théoriques</strong> de début et de fin prévue, ainsi que le montant estimé.</li>
        <li>Enregistrer — la maintenance est créée au statut <em>En attente</em>.</li>
      </ul>
      <div class="tip">
        Une maintenance <em>En attente</em> peut être modifiée ou supprimée. Une fois démarrée, seule l'annulation est possible.
      </div>

      <h4 class="manuel-subsection">Suivre l'exécution (Exécution)</h4>
      <ul class="steps">
        <li>La liste affiche toutes les maintenances avec leur <strong>progression</strong> (barre de progression) et leur <strong>statut</strong>.</li>
        <li>Cliquer sur <strong>▶ Démarrer</strong> pour passer une maintenance de <em>En attente</em> à <em>En cours</em>. La date de début réelle est enregistrée.</li>
        <li>Cliquer sur <strong>✓ Terminer</strong> pour clore une maintenance. La date de fin réelle est enregistrée.</li>
        <li>Cliquer sur <strong>✕ Annuler</strong> pour annuler une maintenance en attente ou en cours.</li>
        <li>Le bouton <strong>👁 Détail</strong> permet de consulter et modifier les informations complètes.</li>
      </ul>

      <h4 class="manuel-subsection">Statuts possibles</h4>
      <div class="features-grid" style="grid-template-columns:repeat(auto-fill,minmax(160px,1fr));">
        <div class="feature-card"><strong style="color:#6c757d;">En attente</strong>Planifiée, pas encore démarrée.</div>
        <div class="feature-card"><strong style="color:#0d6efd;">En cours</strong>Intervention démarrée.</div>
        <div class="feature-card"><strong style="color:#198754;">Terminé</strong>Intervention clôturée.</div>
        <div class="feature-card"><strong style="color:#dc3545;">Annulé</strong>Intervention annulée.</div>
      </div>
    </div>
  </div>

  <!-- ===== GED ===== -->
  <div class="manuel-section" id="ged" *ngIf="activeSection === 'ged'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#5e60ce,#3a3c8e)">
      <div class="manuel-section-num">14</div>
      <mat-icon>folder_open</mat-icon>
      <h3>Documents (GED)</h3>
    </div>
    <div class="manuel-section-body">
      <p>
        La GED (Gestion Électronique de Documents) est la bibliothèque centralisée de tous les documents générés par l'application :
        états globaux, rapports de stock, bilans financiers, etc.
      </p>
      <ul class="steps">
        <li>Accéder à la GED depuis le menu <strong>Documents</strong>.</li>
        <li>Utiliser la barre de recherche pour trouver un document par son libellé ou sa référence.</li>
        <li>La liste affiche le nom du document, sa référence, l'utilisateur qui l'a généré et la date de création.</li>
      </ul>

      <h4 class="manuel-subsection">Actions disponibles</h4>
      <div class="features-grid" style="grid-template-columns:repeat(auto-fill,minmax(200px,1fr));">
        <div class="feature-card">
          <strong style="color:#dc3545;">PDF</strong>
          Cliquer sur l'icône <em>œil</em> pour prévisualiser le document, ou sur l'icône <em>PDF</em> pour le télécharger.
        </div>
        <div class="feature-card">
          <strong style="color:#198754;">Excel</strong>
          Cliquer sur l'icône <em>tableau</em> pour télécharger le fichier Excel correspondant.
        </div>
        <div class="feature-card">
          <strong style="color:#0dcaf0;">Image</strong>
          Cliquer sur l'icône <em>image</em> pour ouvrir le fichier image dans un nouvel onglet.
        </div>
      </div>
      <div class="tip">
        <strong>Génération des documents</strong>
        Les documents sont générés automatiquement lors de certaines actions (ex : impression d'un état global, rapport de stock).
        Ils sont ensuite archivés ici et restent accessibles à tout moment sans régénérer le rapport.
      </div>
    </div>
  </div>

  <!-- ===== AUDIT ===== -->
  <div class="manuel-section" id="audit" *ngIf="activeSection === 'audit'">
    <div class="manuel-section-header" style="background:linear-gradient(135deg,#212529,#495057)">
      <div class="manuel-section-num">17</div>
      <mat-icon>manage_search</mat-icon>
      <h3>Audit &amp; Logs</h3>
    </div>
    <div class="manuel-section-body">
      <p>
        Le module Audit permet aux administrateurs de tracer et contrôler toutes les activités des utilisateurs sur la plateforme.
        Accessible uniquement aux profils ayant les habilitations appropriées.
      </p>
      <div class="features-grid">
        <div class="feature-card">
          <strong>Historique des connexions</strong>
          Consulter la liste de toutes les connexions : utilisateur, date, heure et adresse IP.
        </div>
        <div class="feature-card">
          <strong>Historique de navigation</strong>
          Tracer les pages visitées par chaque utilisateur avec l'horodatage.
        </div>
        <div class="feature-card">
          <strong>Logs API</strong>
          Journal technique des appels API : endpoint, méthode, statut HTTP, durée et utilisateur.
        </div>
      </div>

      <h4 class="manuel-subsection">Historique des connexions</h4>
      <ul class="steps">
        <li>Consulter qui s'est connecté, à quelle heure et depuis quelle adresse IP.</li>
        <li>Filtrer par période ou par utilisateur pour cibler une investigation.</li>
        <li>Utile pour détecter des connexions suspectes ou non autorisées.</li>
      </ul>

      <h4 class="manuel-subsection">Historique de navigation</h4>
      <ul class="steps">
        <li>Voir les modules et pages consultés par chaque utilisateur.</li>
        <li>Permet de vérifier qu'un utilisateur n'a pas accédé à des fonctionnalités non autorisées.</li>
      </ul>

      <h4 class="manuel-subsection">Logs API</h4>
      <ul class="steps">
        <li>Journal bas niveau de toutes les requêtes passées vers le serveur.</li>
        <li>Affiche le endpoint, la méthode HTTP (GET/POST), le code de réponse et la durée d'exécution.</li>
        <li>Utile pour le diagnostic technique et la détection d'anomalies de performance.</li>
      </ul>

      <div class="warning">
        L'accès au module Audit est réservé aux administrateurs. Attribuer les fonctionnalités
        <code>HISTORIQUE_CONNEXION</code>, <code>HISTORIQUE_NAVIGATION</code> et <code>LOGS</code> aux rôles concernés.
      </div>
    </div>
  </div>

  </div><!-- /manuel-layout -->

</div><!-- /padding -->
</div><!-- /content-block -->
</div><!-- /content-block-outer -->
</section>
